module.exports = __webpack_public_path__ + "static/img/medicalBanner.bb9144c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medicalBanner.png
// module id = AwZ9
// module chunks = 1